import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  width: 100%;

  .info-button {
    margin-top: ${rem(16)};
    margin-left: -${rem(8)};
  }  
`;

const Table = styled.div`
  display: flex;
  flex-flow: column;
  row-gap: ${rem(16)};
  padding: ${rem(8)} 0;

  @media (max-width: 430px) {
    row-gap: ${rem(24)};
  }
`;

const TableRow = styled.div`
  display: flex;
  gap: ${rem(8)};
  flex-flow: wrap;
`;

const TableHeader = styled.div`
  display: flex;
  column-gap: ${rem(4)};
  flex: 0 0 24%;

  // https://caniuse.com/mdn-css_at-rules_container
  @container main (max-width: 600px) {
    flex-basis: 100%;
  }

  @media (max-width: 600px) {
    flex-basis: 100%;
  }
`;

const TableHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${rem(4)};
  line-height: ${rem(24)};
  height: max-content;
`;

const TableData = styled.div`
  display: flex;
  flex: 1;
  flex-flow: wrap;
  gap: ${rem(8)};
  min-height: ${rem(24)};
  max-width: 100%;
`;

const AudienceList = styled.div`
  display: flex;
  flex-flow: wrap;
  gap: ${rem(8)};
`;

const TooltipContent = styled.div`
  display: flex;
  flex-flow: column wrap;
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
`;

const TooltipFooter = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
  margin-top: ${rem(16)};

  .button {
    font-size: ${rem(12)};
    font-weight: 600;
    height: ${rem(24)};
    margin-left: auto;
    white-space: nowrap;
  }
`;

const SeeMoreButtonWrapper = styled.div`
  width: 100%;
`;

const SeeMoreButton = styled.button`
  color: inherit;
  background: none;
  border: none;
  cursor: pointer;
  font-size: ${rem(12)};
  font-weight: 600;
  line-height: ${rem(16)};
  transition: 200ms ease;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export default {
  Wrapper,
  AudienceList,
  SeeMoreButton,
  SeeMoreButtonWrapper,
  Table,
  TableRow,
  TableHeader,
  TableHeaderLabel,
  TableData,
  TooltipContent,
  TooltipFooter
};
